/* eslint-disable indent */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import LeftArrowIcon from 'material-ui-icons/ArrowBack';
import RightArrowIcon from 'material-ui-icons/ArrowForward';
import EventIcon from 'material-ui-icons/Event';
import {
    handlecheckInChangeFactory, handlecheckOutChangeFactory,
    handleNightsChangeFactory, registerLandScapeForm, handleNightsEnterFactory
} from '../Utils/FilterChangeFunctions';
import moment from 'moment';

import { translate } from 'react-i18next';
import { TextField } from 'material-ui';
import SelectSimple from '../../ui/SelectSimple';


import {
    handleSubmitFactory, setSelectedSuggestionFactory, commonValidateAndCase,
    getAdults, getChildren, getRooms
} from './CommonFunctions';
import AbstractSearchForm from './AbstractSearchForm';
import { DatePicker } from 'material-ui-pickers';
import FullTextSearchField from './FullTextSearchField';
import { Button } from 'material-ui';
import { CircularProgress } from 'material-ui';
import DynIcon from '../Utils/DynIcon';
import SearchOptionsDialog from './SearchOptionsDialog';
import { connect } from 'react-redux';
import { setHotelsNew, noResults, setQuery } from '../../actions/hotelsActions';
import { setSelection } from '../../actions/selectSuggestionActions';


import isEqual from 'lodash.isequal'

const styles = {
    avatar: {
        backgroundColor: 'dark-grey',
        color: 'grey',
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    roomNumberTextField: {
        width: '140px',
        marginBottom: '32px',
    },
    footNoteText: {
        marginTop: '16px',
        fontWeight: 300,
        paddingTop: 0
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '24px'
    }
};

const roomsValues = Array.from(Array(6).keys());
roomsValues.shift();

/**
 * Componente de busqueda general
 *
 * @author Luciano Bustos
 */

class SearchFormLandscape extends AbstractSearchForm {
    constructor(props) {
        super(props);
        registerLandScapeForm(this);
        const { user, classes, tab, searchFormType } = props;
        this.accountName = user ? user.accountName.toLowerCase() : 'default';
        this.prevNigths = 1;
        this.tab = tab;
        this.searchFormType = searchFormType;
        let initialState = this.initState(classes, searchFormType);
        initialState.loading = props.loading;

        this.state = initialState;
    }

    componentDidMount() {
        this.parseParamsToObject();
        this.resultHandler();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location !== this.props.location) {
            this.parseParamsToObject();
        }

        if (Object.entries(this.props.selectedTab).length > 0 && !isEqual(prevProps.selectedTab, this.props.selectedTab)) {
            this.setState({
                searchFormType: this.props.selectedTab.type.id,
                tab: { ...this.props.selectedTab }
            });
        }

    }

    async UNSAFE_componentWillReceiveProps(params) {
        if (params && params.hotels && !params.hotels.query) {
            await this.setState({
                loading: false,
                data: [],
            });
            this.props.dispatch(setQuery());
        }
    }

    /**
     * VTV-413
     * Method to fill the search form when has params in url.
     */
    parseParamsToObject = () => {
        if (!this.props.location) {
            return;
        }

        let state = {
            value: '',
            valueDestination: '',
            suggestions: [],
            selectedSuggestion: {},
        };

        const mapParams = new URLSearchParams(this.props.location);
        const hotelCode = mapParams.get('hotelCode');
        const cityCode = mapParams.get('cityCode');
        const provinceCode = mapParams.get('provinceCode');
        const coastCode = mapParams.get('coastCode');
        const countryCode = mapParams.get('countryCode');
        const checkIn = mapParams.get('checkIn') && moment(mapParams.get('checkIn'));
        const checkOut = mapParams.get('checkOut') && moment(mapParams.get('checkOut'));
        const totalRooms = Number(mapParams.get('rooms'));

        if (!mapParams) {
            return;
        }

        // Check properties to be setted
        switch (true) {
            case !!countryCode:
                state['countryCode'] = countryCode;
            case !!checkIn:
                state['checkIn'] = moment(checkIn, 'DD/MM/YYYY');
            case !!checkOut:
                state['checkOut'] = moment(checkOut, 'DD/MM/YYYY');
            case !!checkIn && !!checkOut:
                state['nights'] = checkOut.diff(checkIn, 'days');
            case !!totalRooms:
                state['totalRooms'] = totalRooms;
        }

        const adults = getAdults(mapParams, totalRooms);
        const children = getChildren(mapParams, totalRooms);

        if (adults.length && children.length && totalRooms) {
            state['rooms'] = getRooms(adults, children, 'ALL', totalRooms);
        }

        this.setState({ ...state });

    }

    resultHandler = (action, data) => {
        this.setState({ loading: false });
        if (data) {
            const hash = window.location.hash;
            this.props.dispatch(setHotelsNew(hash));
        }
    }

    handleFault = async (error, query) => {
        this.props.dispatch(noResults(error.message));
        await this.setState({
            totalRooms: query.rooms.length,
            rooms: query.rooms,
            checkIn: moment(query.checkInDate, 'DD/MM/YYYY'),
            checkOut: moment(query.checkInDate, 'DD/MM/YYYY').add(query.nights, 'days'),
            nights: query.nights,
            selectedSuggestion: query.selectedSuggestion,
            stateCode: query.stateCode,
            townCode: query.townCode,
            countryCode: query.countryCode,
            loading: false,
            data: [],
        });
        alert(error.message);
    }

    handleUpdate = (action, data) => {
        switch (action) {
            case 'result':
                this.setStateFromQuery(data.query, this);
                break;
            default:
                break;
        }
    }

    handleHotelListChange = destinationId => {

        const exclusiveDestinationSelected = this.tab.hotelDestinations[destinationId].hotelIds;

        this.dispatchSelectionState({
            currentIndex: destinationId,
            exclusiveDestinationSelected
        });

        this.setState({
            valueDestination: destinationId,
            exclusiveDestinationSelected,
        });
    };

    handleDestinationChange = destinationId => {
        const exclusiveDestinationSelected = JSON.stringify(this.tab.destinations[destinationId]);
        this.dispatchSelectionState({
            currentIndex: destinationId,
            exclusiveDestinationSelected
        });
        this.setState({
            valueDestination: destinationId,
            exclusiveDestinationSelected: exclusiveDestinationSelected
        });
    };

    dispatchSelectionState(data) {
        if (!data.hasOwnProperty('currentIndex') ||
            !data.hasOwnProperty('exclusiveDestinationSelected')
        ) {
            throw new Error('Todos los campos son necesarios para cargar el estado del SelectSimple');
        }
        this.props.dispatch(setSelection(data));
    }

    initState = (classes, eroskiData) => {

        let { selectSuggestionRedux } = this.props;
        let valueDestinationIdx = selectSuggestionRedux.currentIndex;
        let exclusiveDestinationSelected = this.getInitialExclusiveDestinationValue();

        // Detect if the page has been reloaded
        if (window.performance) {
            if (performance.navigation.type == 1) {
                const dataStored = JSON.parse(localStorage.getItem('selectionHsDs'));
                // If this property is dirty, we know that has information in exclusiveDestinationSelected too
                if (dataStored.hasOwnProperty('currentIndex') && dataStored.currentIndex !== null) {
                    valueDestinationIdx = dataStored.currentIndex;
                    exclusiveDestinationSelected = dataStored.exclusiveDestinationSelected;

                    // Dispatch action to fill SelectSimple component
                    this.dispatchSelectionState({
                        currentIndex: valueDestinationIdx,
                        exclusiveDestinationSelected
                    });
                }
            }

        }

        return {
            classes: classes,
            selectedTab: {},
            inputError: false,
            valueLabel: '',
            totalRooms: 1,
            rooms: [
                {
                    adults: 2,
                    kids: [],
                    mealPlan: 'ALL',
                },
            ],
            checkOut: moment(this.START_DAY).add(1, 'days'),
            checkIn: moment(this.START_DAY),
            nights: 1,
            value: '',
            suggestions: [],
            selectedSuggestion: {},
            loading: true,
            isDestListForm: this.searchFormType === 'DS' ? true : false,
            isHotelListForm: this.searchFormType === 'HS' ? true : false,
            dialogOpen: false,
            valueDestination: valueDestinationIdx,
            exclusiveDestinationSelected: exclusiveDestinationSelected,
            data: eroskiData || [],
        };
    };

    getInitialExclusiveDestinationValue = () => {

        const { selectSuggestionRedux } = this.props;

        if (this.tab && this.tab.type.id === 'DS' && this.tab.destinations.length > 0) {
            const { exclusiveDestinationSelected } = selectSuggestionRedux;
            const data = exclusiveDestinationSelected && Object.entries(exclusiveDestinationSelected).length > 0 && exclusiveDestinationSelected;
            return !data ? JSON.stringify(this.tab.destinations[0]) : data;
        }
        if (this.tab && this.tab.type.id === 'HS' && this.tab.hotelDestinations.length > 0) {
            const { exclusiveDestinationSelected } = selectSuggestionRedux;
            const data = exclusiveDestinationSelected && Object.entries(exclusiveDestinationSelected).length > 0 && exclusiveDestinationSelected;
            return !data ? this.tab.hotelDestinations[0].hotelIds : data;
        }
    };

    /**
     * Return the formatted list of hotels ready to be used by the select native component
     */
    formattedHotelList = (destinations) => {
        return destinations.map((dest, idx) => {
            dest.idx = idx;
            dest.newLabel = dest.label.value;
            return dest;
        });
    }

    getFormattedDestination = (destination) => {
        const normalizedCountry = commonValidateAndCase(destination.countryName);
        const normalizedProvince = commonValidateAndCase(destination.countryDivisionName);
        const normalizedCity = commonValidateAndCase(destination.cityName);
        const normalizedCoast = commonValidateAndCase(destination.coastName);

        let locationMessage = [];
        if (normalizedCoast !== '') {
            locationMessage.push(normalizedCoast);
        }
        if (normalizedCity !== '') {
            locationMessage.push(normalizedCity);
        }
        if (normalizedProvince !== '') {
            locationMessage.push(normalizedProvince);
        }
        if (normalizedCountry !== '') {
            locationMessage.push(normalizedCountry);
        }
        locationMessage = locationMessage.join(', ');
        return locationMessage;
    }

    /**
     * Return the formatted list of destinations ready to be used by the select native component
     */
    formattedDestinationsList = (destinations) => {
        return destinations.map((dest, idx) => {
            dest.idx = idx;
            dest.newLabel = this.getFormattedDestination(dest);
            return dest;
        });
    }


    render() {
        const { classes, t, tab, searchFormType, selectedTab } = this.props;
        const totalAdults = this.state.rooms.reduce((acc, r) => acc + r.adults, 0);
        const totalKids = this.state.rooms.reduce((acc, r) => acc + r.kids.length, 0);
        const loadingCSS = this.state.loading ? ' blur' : '';
        const { valueDestination } = this.state;

        let firstColumns = '';

        if (searchFormType === 'H') {
            firstColumns =
                <FullTextSearchField
                    setSelectedSuggestion={setSelectedSuggestionFactory(this)}
                    value={this.state.value}
                    selectedSuggestion={this.state.selectedSuggestion}
                    inputError={this.state.inputError} />;


        } else if (tab.type.id === 'DS') {
            if (tab.destinations.length <= 1) {
                tab.image ?
                    (firstColumns = <div className={tab.image.degraded ? 'imageGradient' : ''}><img src={tab.image.url ? tab.image.url : ''} alt="Destination Logo" className="cmsImageSearchForm" /></div>) :
                    firstColumns = <h1>{this.getFormattedDestination(tab.destinations[0])}</h1>;
            } else {
                firstColumns =
                    <SelectSimple id={'test 1'}
                        label={t('HOME.DESTINATION')}
                        labelProp="newLabel" codeProp="idx"
                        selection={valueDestination ? valueDestination : null}
                        disabled={this.state.loading}
                        onChange={(val) => {
                            this.handleDestinationChange(val);
                        }}
                        options={this.formattedDestinationsList(tab.destinations)} />;

            }
        } else if (tab.type.id === 'HS') {
            if (tab.hotelDestinations.length <= 1) {
                tab.image ?
                    (firstColumns = <div className={tab.image.degraded ? 'imageGradient' : ''}><img src={tab.image.url ? tab.image.url : ''} alt="Hotel Logo" className="cmsImageSearchForm" /></div>) :
                    firstColumns = <h1>{tab.hotelDestinations[0].label.value}</h1>;
            } else {
                firstColumns =
                    <SelectSimple id={'test 2'}
                        label={t('HOME.DESTINATION')}
                        labelProp="newLabel" codeProp="idx"
                        selection={valueDestination ? valueDestination : null}
                        onChange={(val) => {
                            this.handleHotelListChange(val);
                        }}
                        options={this.formattedHotelList(tab.hotelDestinations)} />;
            }
        }

        return (
            <div className="SearchFormLandscape">
                <table width="100%" className={'cmsTable' + loadingCSS}>
                    <tbody>
                        <tr>
                            <td className="fts">

                                {firstColumns}
                            </td>
                            <td className="checkin">
                                <DatePicker
                                    keyboard
                                    label={t('COMMON.CHECK_IN')}
                                    format={'DD/MM/YYYY'}
                                    autoOk
                                    leftArrowIcon={<LeftArrowIcon />}
                                    rightArrowIcon={<RightArrowIcon />}
                                    disablePast
                                    keyboardIcon={
                                        <EventIcon className="cmsIcon" />
                                    }
                                    value={this.state.checkIn}
                                    onChange={handlecheckInChangeFactory(this)}
                                    animateYearScrolling={false} className="cmsFormContainer"
                                    disabled={this.state.loading}
                                    minDateMessage={t('HOME.DATE_VALIDATION')}
                                    invalidDateMessage={t('HOME.INVALID_FORMAT')}
                                />
                            </td>
                            <td className="nights">
                                <TextField
                                    label={t('COMMON.NIGHTS')}
                                    value={this.state.nights}
                                    onChange={handleNightsChangeFactory(this)}
                                    onBlur={(e) => { handleNightsEnterFactory(e, this); }}
                                    onKeyDown={(e) => { handleNightsEnterFactory(e, this); }}
                                    type="number"
                                    className="cmsFormContainer"
                                    inputProps={{ min: 1, max: this.MAX_NIGHTS }}
                                    disabled={this.state.loading}
                                />
                            </td>
                            <td className="checkout">
                                <DatePicker
                                    keyboard
                                    label={t('COMMON.CHECK_OUT')}
                                    className="cmsFormContainer"
                                    format={'DD/MM/YYYY'}
                                    autoOk
                                    leftArrowIcon={<LeftArrowIcon />}
                                    rightArrowIcon={<RightArrowIcon />}
                                    disablePast
                                    keyboardIcon={
                                        <EventIcon className="cmsIcon" />
                                    }
                                    value={this.state.checkOut}
                                    onChange={handlecheckOutChangeFactory(this)}
                                    animateYearScrolling={false}
                                    disabled={this.state.loading}
                                    minDateMessage={t('HOME.DATE_VALIDATION')}
                                    invalidDateMessage={t('HOME.INVALID_FORMAT')} />
                            </td>
                            <td className="adults">
                                <TextField
                                    label={t('HOME.TOTAL_ADULTS')}
                                    name={'adults'} fullWidth
                                    className="cmsFormContainer disabled"
                                    value={totalAdults}
                                    onChange={this.handleChange}
                                    SelectProps={{
                                        MenuProps: {
                                            className: classes.menu,
                                        },
                                    }}
                                    disabled={true}
                                />
                            </td>
                            <td className="childrens">
                                <TextField
                                    label={t('HOME.TOTAL_CHILDREN') + ' **'}
                                    name={'children'}
                                    className="cmsFormContainer disabled"
                                    value={totalKids}
                                    onChange={this.handleChange}
                                    SelectProps={{
                                        MenuProps: {
                                            className: classes.menu,
                                        },
                                    }}
                                    disabled={true}
                                />
                            </td>
                            <td className="rooms">
                                <TextField
                                    label={t('COMMON.ROOMS')}
                                    name={'totalRooms'}
                                    className="cmsFormContainer"
                                    value={this.state.totalRooms}
                                    onClick={this.handleOpenDialog}
                                    disabled={this.state.loading}>
                                </TextField>
                                <SearchOptionsDialog
                                    rooms={this.state.rooms}
                                    totalRooms={this.state.totalRooms}
                                    open={this.state.dialogOpen}
                                    onClose={this.handleCloseDialog}
                                />
                            </td>
                            <td className="search">
                                <Button color="primary"
                                    onClick={() => {
                                        handleSubmitFactory(this)();
                                        this.props.onSearch && this.props.onSearch();
                                    }}
                                    disabled={this.state.loading}
                                    title={t('HOME.SEARCH_BUTTON')}
                                    className="cmsButtonSearch">
                                    {this.state.loading
                                        ? <CircularProgress className="buttonProgressIcon" />
                                        :
                                        <DynIcon icon="Search"
                                            style={{
                                                color: 'var(--primary-button--text-color)',
                                                minWidth: '38px',
                                                height: '38px',
                                            }}
                                        />
                                    }
                                </Button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    hotels: state.hotelsRedux,
    noResults: state.hotelsRedux.noResults,
    location: state.hotelsRedux.params,
    selectedTab: state.tabsRedux.selectedTab,
    selectSuggestionRedux: state.selectSuggestionRedux,
});

SearchFormLandscape.propTypes = {
    classes: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    tab: PropTypes.object,
    searchFormType: PropTypes.string,
    onClose: PropTypes.func,
    onSearch: PropTypes.func,
};
export default connect(mapStateToProps)(translate('translations')(withStyles(styles)(SearchFormLandscape))); 


// WEBPACK FOOTER //
// ./src/components/SearchContent/SearchFormLandscape.js